import React, { createContext } from "react";

// Context for accessing local storage from anywhere in the app (see React Context)
const LocalStorageContext = createContext();

export default LocalStorageContext;
